import globals from "./globals";
import $ from "cash-dom";
import Swiper from "swiper";
import { EffectFade, Manipulation, Navigation } from "swiper/modules";

const component = (function () {
    $(document).ready(function () {
        $("button[data-action='lightbox-single']").on("click", function (_e) {
            var html = $(_e.target).parents("figure").find("img").clone();
            $(".lightbox-media").append(html);
            $(".lightbox").addClass("on").removeClass("pointer-none");
            $("[data-action='close-lightbox']").addClass("pointer-all").removeClass("pointer-none");
        });

        /**
         * Initialize contextual slider
         */
        $('.layout-contact-sheet [data-action="lightbox-slider"]').on("click", function (_e) {
            var container = $(_e.target).closest(".contact-sheet")[0];
            var initialIndex = $(_e.target).closest(".contact-sheet-image").attr("data-index");
            var slider = $(".lightbox-media");
            var slides = $(container).find(".contact-sheet-image");
            var buttonPrev = $(".lightbox-button-prev")[0];
            var buttonNext = $(".lightbox-button-next")[0];
            var swiperInstance;

            // Populate slider
            slides.each(function () {
                var index = $(this).attr("data-index");
                var html = $(this).find(".image-element").html();
                var caption = $(this).find(".caption");

                slider.append(`<div class="swiper-slide">${html}</div>`);

                if (caption.length) {
                    var appendClass = index === initialIndex ? " on" : "";
                    console.log(index === initialIndex);
                    $(".lightbox-description").append(
                        `<div class="caption text-white fade-in${appendClass} transition-sm" data-describes="${index}">${caption.html()}</div>`
                    );
                }
            });

            // Initialize slider
            swiperInstance = new Swiper(".lightbox-content", {
                effect: "fade",
                initialSlide: initialIndex,
                modules: [EffectFade, Manipulation, Navigation],
                navigation: {
                    nextEl: buttonNext,
                    prevEl: buttonPrev,
                },
            });

            // Display descriptions
            swiperInstance.on("slideChange", function () {
                var activeIndex = swiperInstance.activeIndex;
                $(".lightbox-description [data-describes]").removeClass("on");
                $(`.lightbox-description [data-describes='${activeIndex}']`).addClass("on");
            });

            // Show slider
            $(".lightbox-controls").removeClass("hidden");
            $(".lightbox").addClass("on").removeClass("pointer-none");
        });

        $("button[data-action='close-lightbox']").on("click", function () {
            $(".lightbox-description [data-describes]").removeClass("on");
            $(".lightbox-controls").addClass("hidden");
            $(".lightbox-media").html(null);
            $(".lightbox-description").html(null);
            $(".lightbox").removeClass("on").addClass("pointer-none");
            $("[data-action='close-lightbox']").removeClass("pointer-all").addClass("pointer-none");
        });

        $(window).on("keydown", function (e) {
            if (e.key == "Escape") {
                $(".lightbox-description [data-describes]").removeClass("on");
                $(".lightbox-controls").addClass("hidden");
                $(".lightbox-media").html(null);
                $(".lightbox-description").html(null);
                $(".lightbox").removeClass("on").addClass("pointer-none");
                $("[data-action='close-lightbox']").removeClass("pointer-all").addClass("pointer-none");
            }
        });
    });
})();

export default component;
